// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1qm2a","options":"AnswerScale_options__36gpQ","selected":"AnswerScale_selected__23ORX"};